<template>
  <a-form class="m-b-20" ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="操作日期" name='time'>
      <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
    </a-form-item>
    <a-form-item>
      <a-select v-model:value="search.card_id" :style="{width:'140px'}">
        <a-select-option value="">全部会员卡</a-select-option>
        <a-select-option v-for='(item,index) in vipList' :key="index" :value="item.vip_id">{{item.vip_name}}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange"  :show-total="total => `总数: ${total} `" />
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getMemberVip, getVipLog } from "@/api/member.js";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  const def = {
    page: 1,
    limit: 5,
    card_id: "",
    start_time: '',
    end_time: ''
  };
  export default {
    components: {},
    setup(props, { emit }) {
      const search = ref({...def});
      let data = ref([]);
      const state = reactive({
        listLoading: false,
        vipList: [],
        total: 0,
        time:[]
      });
      let columns = [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "名称",
          dataIndex: "vip_name",
          key: "vip_name",
        },
        {
          title: "成长值",
          dataIndex: "vip_exp",
          key: "vip_exp"
        },
        {
          title: "操作时间",
          dataIndex: "create_time",
          key: "create_time"
        },
        {
          title: "操作者",
          dataIndex: "brand_name",
          key: "brand_name"
        },
        {
          title: "操作内容",
          dataIndex: "type_text",
          key: "type_text"
        },
      ];
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      //获取会员卡列表
      const getVip = async () => {
        let res = await getMemberVip().then(res => res.data);
        if (iscode(res)) {
          state.vipList = res.data;
        } else {
          message.error(res.msg);
        }
      };
      //获取记录
      const initData = async () => {
        state.listLoading = true;
        let res = await getVipLog(search.value).then(res => res.data);
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
        state.listLoading = false;
      };
      onMounted(() => {
        initData();
        getVip();
      });
      return {
        ...toRefs(state),
        data,
        columns,
        search,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange
      };
    },
  };
</script>